import React from "react";
import "./FeatureCards.css";

const FeatureCards = () => {
  const features = [
    {
      number: "50%",
      title: "Australian Women",
      description:
        "Feel safe walking alone at night. But more than 80% of Australian men feel safe.",
    },
    {
      number: "63%",
      title: "Australian Women",
      description:
        "Did not walk alone in their local area after dark, compared to only 31% of men.",
    },
    {
      number: "21.6%",
      title: "Young Female",
      description:
        "Report personal safety as a concern, in contrast to young males(14.3%).",
    },
  ];

  return (
    <div className="feature-cards-container">
      {features.map((feature, index) => (
        <div key={index} className="feature-card">
          <h2 className="feature-number">{feature.number}</h2>
          <h3 className="feature-title">{feature.title}</h3>
          <p className="feature-description">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default FeatureCards;
